import { Skeleton } from 'antd';
import React from 'react';
import './styles.scss';

export const CompanyListItemSkeleton: React.FC = (props) => {
  return <Skeleton className='company-list-item-skeleton' loading paragraph={{ rows: 2 }} />;
};
